import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-red-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Card>
          <CardHeader>
            <CardTitle className="text-3xl font-heading">Terms of Service</CardTitle>
            <p className="text-sm text-gray-500">Last updated: November 27, 2024</p>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Acceptance of Terms</h2>
              <p className="text-gray-700">
                By accessing and using Speak Algerian ("the Service"), you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to these terms, please do not use the Service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Description of Service</h2>
              <p className="text-gray-700">
                Speak Algerian provides an online platform for learning Algerian Arabic (Derja) through vocabulary lessons, interactive games, and audio pronunciations. The Service is available via monthly subscription.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Subscription and Payment</h2>
              <div className="text-gray-700 space-y-2">
                <p><strong>3.1 Subscription Fee:</strong> Access to the Service requires a paid monthly subscription of £9.99 per month, unless you have applied a valid promotional code.</p>
                <p><strong>3.2 Billing:</strong> Subscriptions are billed monthly and will automatically renew unless cancelled.</p>
                <p><strong>3.3 Payment Processing:</strong> Payments are processed securely through Stripe. By subscribing, you agree to Stripe's terms of service.</p>
                <p><strong>3.4 Promotional Codes:</strong> Promotional codes may offer discounts or free access. Promotional terms are subject to change and may be revoked at any time.</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Cancellation and Refunds</h2>
              <div className="text-gray-700 space-y-2">
                <p><strong>4.1 Cancellation:</strong> You may cancel your subscription at any time. Cancellation will take effect at the end of your current billing period.</p>
                <p><strong>4.2 Refunds:</strong> We do not offer refunds for partial months. Once billed, your subscription fee is non-refundable.</p>
                <p><strong>4.3 Access:</strong> Upon cancellation, you will retain access until the end of your paid period.</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">5. User Accounts</h2>
              <div className="text-gray-700 space-y-2">
                <p><strong>5.1 Account Creation:</strong> You must create an account to use the Service. You are responsible for maintaining the confidentiality of your account credentials.</p>
                <p><strong>5.2 Account Security:</strong> You are responsible for all activities that occur under your account.</p>
                <p><strong>5.3 Account Termination:</strong> We reserve the right to suspend or terminate accounts that violate these terms.</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Intellectual Property</h2>
              <p className="text-gray-700">
                All content, including but not limited to text, graphics, logos, audio clips, and software, is the property of Speak Algerian and is protected by copyright and intellectual property laws. You may not reproduce, distribute, or create derivative works without explicit permission.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">7. User Conduct</h2>
              <p className="text-gray-700">
                You agree not to use the Service for any unlawful purpose or in any way that could damage, disable, or impair the Service. You will not attempt to gain unauthorized access to any part of the Service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Disclaimer of Warranties</h2>
              <p className="text-gray-700">
                The Service is provided "as is" without warranties of any kind, either express or implied. We do not guarantee that the Service will be uninterrupted, timely, secure, or error-free.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Limitation of Liability</h2>
              <p className="text-gray-700">
                Speak Algerian shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the Service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Changes to Terms</h2>
              <p className="text-gray-700">
                We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through the Service. Continued use of the Service after changes constitutes acceptance of the new terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">11. Contact Information</h2>
              <p className="text-gray-700">
                If you have any questions about these Terms of Service, please contact us at:
                <br />
                Email: speakalgerian.contact@gmail.com
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">12. Governing Law</h2>
              <p className="text-gray-700">
                These terms shall be governed by and construed in accordance with the laws of England and Wales, without regard to its conflict of law provisions.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfService;
